export default __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.49a8e66a.ttf";